<template>
  <div>
    <payment-gateway
      :toolbar="toolbar"
      :paypal="paypal"
      :compact="compact"
      ref="paymentGateway"
      @gateway="listenGateway"
      @card="listenCard"
      @card-switch="listenCardNew"
      @close="closeModal"
    >
      <template v-slot:header>Invoice Payment</template>
      <template v-slot:actions>
        <gg-btn secondary @click="closeModal" >
          Cancel
        </gg-btn>
        <gg-btn primary :loading="payment_loading" @click="makePayment" >
          {{ payBtnTitle }}
        </gg-btn>
      </template>
    </payment-gateway>
    <form v-if="gateway === 'paypal'"
          method="post"
          ref="frm_paypal"
          style="display:none;">
      <input type="hidden" name="cmd" value="_s-xclick">
      <input type="text" ref="paypal_encrypted" name="encrypted">
      <input type="submit" value="">
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PaymentGateway from '@/components/Common/PaymentGateway'

export default {
  name: 'InvoicePayment',
  props: {
    invoice: {
      type: Object,
      required: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    toolbar: {
      type: Boolean,
      default: true
    },
    paypal: {
      type: Boolean,
      default: true
    }
  },
  components: {
    PaymentGateway,
  },
  data: () => ({
    gateway: '',
    isCardNew: false,
    model: {
      cardnum: '',
      cardnum_cvv: '',
      expdate: ''
    },
    payment_loading: false,
    tooltip: {
      text: 'For increased security, GreenGeeks is a PCI-DSS compliant organization. This means that CVV/CVC is not saved in order to prevent fraudulent transactions.',
      show: false
    },
  }),
  methods: {
    ...mapActions({
      payInvoice: 'billing/payInvoice',
      getProfile: 'getProfile',
      reportError: 'reportError',
      reportSuccess: 'reportSuccess',
    }),
    listenGateway (gateway) {
      this.gateway = gateway
    },
    listenCard (card) {
      this.model = card
    },
    listenCardNew (card) {
      this.isCardNew = card
    },
    submitPaypalForm (val, endpoint) {
      this.$refs.paypal_encrypted.value = val
      this.$refs.frm_paypal.action = endpoint
      this.$refs.frm_paypal.submit()
    },
    checkPayment () {
      switch (this.$route.query.return) {
        case '1':
          this.reportSuccess('Payment Succeeded')
          this.$router.replace(`/billing/${this.invoice.id}`)
          break
        case '2':
          this.reportError('Payment Cancelled')
          this.$router.replace(`/billing/${this.invoice.id}`)
          break
      }
    },
    async makePayment () {
      const valid = await this.$refs.paymentGateway.validateForm()
      if (!valid) return
      try {
        switch (this.gateway) {
          case 'paypal':
            const d1 = {
              id: this.invoice.id,
              method: 'paypal',
            }
            const r1 = await this.payInvoice(d1)

            if (r1.form && r1.endpoint) {
              this.reportSuccess('Transferring to PayPal, please wait...')
              this.submitPaypalForm(r1.form, r1.endpoint)
            } else {
              this.reportError('Unexpected Error')
            }
            break
          case 'credit_card':
            this.payment_loading = true
            const d2 = {
              id: this.invoice.id,
              method: 'creditcard',
              cvv: this.payment_cvv,
              cc: 'primary',
              cardnum: this.isCardNew ? this.model.cardnum : '',
              expdate: this.isCardNew ? this.model.expdate : '',
              cardnum_cvv: this.model.cardnum_cvv
            }
            // R2D2 lol
            const r2 = await this.payInvoice(d2)

            if (r2.payment_status) {
              this.payment_loading = false
              this.reportSuccess('Payment Approved')
              this.$emit('payment-complete')
            } else {
              this.payment_loading = false
              this.reportError('Payment Declined')
            }
        }
        this.closeModal()
      } catch (e) {
        this.reportError(e)
      }
    },
    closeModal () {
      this.$emit('close')
    }
  },
  computed: {
    ...mapGetters(['SessionProfile']),
    payBtnTitle () {
      switch (this.gateway) {
        case 'paypal':
          return 'Pay with PayPal'
        case 'credit_card':
          return 'Pay with a credit card'
        default:
          return ''
      }
    },
  },
  provide () {
    return {
      $validator: this.$validator,
    }
  },
  created () {
    this.checkPayment()
  }
}
</script>
